import {
    createAsyncThunk,
    createEntityAdapter,
    createSlice,
  } from "@reduxjs/toolkit";
  import {
    createSmsAssignmentsToMachine,
    deleteSmsAssignmentsToMachine,
    getSmsAssignments,
    getSmsAssignmentsToMachine,
    updateSmsAssignmentsToMachine,
  } from "data/server_apis/commodityService";
  
  const smsAssignmentsToMachineAdapter = createEntityAdapter({
    selectId: (validationAssignment) => validationAssignment.id,
  });
  
  export const getSmsAssignmentsToMachinesThunk = createAsyncThunk(
    "SmsAssignmentsToMachines/get",
    async (id, { rejectWithValue }) => {
      try {
        return (await getSmsAssignmentsToMachine(id)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );

  export const getSmsAssignmentsThunk = createAsyncThunk(
    "SmsAssignments/get",
    async (_, { rejectWithValue }) => {
      try {
        return (await getSmsAssignments()).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  export const createSmsAssignmentsToMachineThunk = createAsyncThunk(
    "SmsAssignmentsToMachines/create",
    async (data, { rejectWithValue }) => {
      try {
        return (await createSmsAssignmentsToMachine(data)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  export const updateSmsAssignmentsToMachineThunk = createAsyncThunk(
    "SmsAssignmentsToMachine/update",
    async ({ id, data }, { rejectWithValue }) => {
      try {
        return (await updateSmsAssignmentsToMachine(id, data)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  export const deleteSmsAssignmentsToMachineThunk = createAsyncThunk(
    "SmsAssignmentsToMachine/delete",
    async (id, { rejectWithValue }) => {
      try {
        return (await deleteSmsAssignmentsToMachine(id)).data;
      } catch (err) {
        const customError = {
          name: err.response?.status,
          message: err.response?.status === 400 ? err.response?.data : null,
        };
        // console.log("Error", customError);
        return rejectWithValue(customError);
      }
    }
  );
  
  const smsAssignmentsToMachinesSlice = createSlice({
    name: "smsAssignmentsToMachine",
    initialState: smsAssignmentsToMachineAdapter.getInitialState({
      status: {},
    }),
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(
          getSmsAssignmentsToMachinesThunk.pending,
          (state, action) => {
            state.status = { loading: "get", id: action.meta.arg };
          }
        )
        .addCase(
          getSmsAssignmentsToMachinesThunk.rejected,
          (state, action) => {
            state.status = {
              error: "get",
              errorMessage: action.payload?.message,
               id: action.meta.arg 
            };
          }
        )
        .addCase(
          getSmsAssignmentsToMachinesThunk.fulfilled,
          (state, action) => {
            state.status = { success: "get",id: action.meta.arg  };
            smsAssignmentsToMachineAdapter.setAll(state, action.payload);
          }
        );
        builder
        .addCase(
          getSmsAssignmentsThunk.pending,
          (state, action) => {
            state.status = { loading: "get" };
          }
        )
        .addCase(
          getSmsAssignmentsThunk.rejected,
          (state, action) => {
            state.status = {
              error: "get",
              errorMessage: action.payload?.message
            };
          }
        )
        .addCase(
          getSmsAssignmentsThunk.fulfilled,
          (state, action) => {
            state.status = { success: "get" };
            smsAssignmentsToMachineAdapter.setAll(state, action.payload);
          }
        );
  
      builder
        .addCase(
          createSmsAssignmentsToMachineThunk.pending,
          (state, action) => {
            state.status = { loading: "create" };
          }
        )
        .addCase(
          createSmsAssignmentsToMachineThunk.rejected,
          (state, action) => {
            state.status = {
              error: "create",
              errorMessage: action.payload?.message,
            };
          }
        )
        .addCase(
          createSmsAssignmentsToMachineThunk.fulfilled,
          (state, action) => {
            state.status = { success: "create" };
            smsAssignmentsToMachineAdapter.addOne(state, action.payload);
          }
        );
  
      builder
        .addCase(
          updateSmsAssignmentsToMachineThunk.pending,
          (state, action) => {
            state.status = { loading: "update", id: action.meta.arg.id };
          }
        )
        .addCase(
          updateSmsAssignmentsToMachineThunk.rejected,
          (state, action) => {
            state.status = {
              error: "update",
              errorMessage: action.payload?.message,
              id: action.meta.arg.id,
            };
          }
        )
        .addCase(
          updateSmsAssignmentsToMachineThunk.fulfilled,
          (state, action) => {
            state.status = { success: "update" };
            smsAssignmentsToMachineAdapter.updateOne(state, {
              id: action.meta.arg.id,
              changes: action.payload,
            });
          }
        );
  
      builder
        .addCase(
          deleteSmsAssignmentsToMachineThunk.pending,
          (state, action) => {
            state.status = { loading: "delete", id: action.meta.arg };
          }
        )
        .addCase(
          deleteSmsAssignmentsToMachineThunk.rejected,
          (state, action) => {
            state.status = {
              id: action.meta.arg,
              error: "delete",
              errorMessage: action.payload?.message,
            };
          }
        )
        .addCase(
          deleteSmsAssignmentsToMachineThunk.fulfilled,
          (state, action) => {
            state.status = { success: "delete", id: action.meta.arg };
            smsAssignmentsToMachineAdapter.removeOne(
              state,
              action.meta.arg
            );
          }
        );
    },
  });
  export const smsAssignmentsToMachineSelector =
    smsAssignmentsToMachineAdapter.getSelectors(
      (state) => state.smsAssignments
    );
  
  export const {} = smsAssignmentsToMachinesSlice.actions;
  
  export default smsAssignmentsToMachinesSlice.reducer;
  